module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-hairmakerehearsal-570e0cbe779eca3865a983b9a682d7f0.png";